export default "__VITE_ASSET__DjvNKzc1__"